import * as React from 'react';
import { observer } from 'mobx-react';
import { LiveCategoryStore } from '../../models/live/liveCategory';
import { IOdd } from 'eTip--common';
import { LeftMenuCategory } from 'desktop--design-library';
import { pushToEventDetail } from '../../liveRouting';
import { Instance } from 'mobx-state-tree';

export interface LeftMenuCategoryContainer {
    category: Instance<typeof LiveCategoryStore>;
    activeTips: { [key: string]: string };
    inactiveTips: { [key: string]: string };
    isLeftColumnCollapsed: boolean;
    isEventPopUpVisible: boolean;
    popupOffset: number;
    isFavorite: boolean;
    onSelectTip: (odd: IOdd, event: any) => void;
    onSetAsFavorite: (eventId: number, isFavorite: boolean) => void;
    onToggleExpand: () => void;
    onToggleEventsPopupVisible: (offset: number) => void;
    onSetCategoryFavorite: () => void;
    onMatchTrackerClick: (event: any) => void
}


export const LeftMenuCategoryContainer: React.FC<LeftMenuCategoryContainer> = observer((props: LeftMenuCategoryContainer) => {
    return <LeftMenuCategory
        category={props.category}
        isEventPopUpVisible={props.isEventPopUpVisible}
        isLeftColumnCollapsed={props.isLeftColumnCollapsed}
        onSelectTip={props.onSelectTip}
        onSetAsFavorite={props.onSetAsFavorite}
        activeTips={props.activeTips}
        inactiveTips={props.inactiveTips}
        onToggleExpand={props.onToggleExpand}
        goToDetail={(detailId: number, canOpenLiveStream: boolean) => { pushToEventDetail(detailId, false, canOpenLiveStream) }}
        onToggleEventsPopupVisible={props.onToggleEventsPopupVisible}
        popupOffset={props.popupOffset}
        isFavorite={props.isFavorite}
        onSetCategoryFavorite={props.onSetCategoryFavorite}
        onMatchTrackerClick={props.onMatchTrackerClick}
    />
})